import { motion } from 'motion/react';
import type { IframePoolOfferOdds, VolatilityLevel } from '../../../../modules/api';
import { OddsStyleContent } from '../OddsSheet';

export interface OddsPopoverProps {
  odds: IframePoolOfferOdds;
  volatility: VolatilityLevel;
  onVolatilityChange: (level: VolatilityLevel) => void;
  onClose: () => void;
}

const TITLE_ID = 'odds-popover-title';

/**
 * Sleek's desktop odds picker: the mobile sheet's content as a card over the
 * sidebar. It anchors to the sidebar's top (OddsPanel stays `static` on
 * desktop) and grows down — the space above the stats block only fits the
 * old compact breakdown, not six rows plus Apply. A click outside closes.
 */
export function OddsPopover({ odds, volatility, onVolatilityChange, onClose }: OddsPopoverProps) {
  return (
    <>
      <div className="fixed inset-0 z-40" aria-hidden onClick={onClose} />
      <motion.section
        role="dialog"
        aria-labelledby={TITLE_ID}
        data-co-component="OddsSheet"
        className="absolute inset-x-0 top-0 z-50 p-6 shadow-[0_24px_60px_0_rgba(0,0,0,0.45)] bg-[var(--co-OddsSheet-background,#0E0F11)] [border-radius:var(--co-OddsSheet-borderRadius,28px)]"
        style={{ transformOrigin: 'top center' }}
        initial={{ opacity: 0, y: -8, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -8, scale: 0.98 }}
        transition={{ duration: 0.18, ease: [0.16, 1, 0.3, 1] }}
      >
        <OddsStyleContent
          odds={odds}
          volatility={volatility}
          onVolatilityChange={onVolatilityChange}
          onClose={onClose}
          titleId={TITLE_ID}
        />
      </motion.section>
    </>
  );
}
